import { render, staticRenderFns } from "./HeaderCrumbs.vue?vue&type=template&id=cdf53dd0&scoped=true"
import script from "./HeaderCrumbs.vue?vue&type=script&lang=js"
export * from "./HeaderCrumbs.vue?vue&type=script&lang=js"
import style0 from "./HeaderCrumbs.vue?vue&type=style&index=0&id=cdf53dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf53dd0",
  null
  
)

export default component.exports